import React, { useEffect } from "react";
import { Layout } from "antd";
import { Headers } from "./Headers";
import { Siders } from "./Siders";
import Breadcrumbs from "./Breadcrumbs";
import WrapperContent from "./WrapperContent";
import { useLocation } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";
import { profileStore } from "src/stores/profile-store";
import "./Css/Layout.css";
import Footers from "./Footers";

const { Content } = Layout;
interface LayoutAppProps {
  children: React.ReactNode; // This type is appropriate for children in React components
}
export const LayoutApp = (props: LayoutAppProps) => {
  const location = useLocation();
  const [width, setWidth] = React.useState(window.innerWidth);
  const profile = profileStore(useShallow((state) => state.profile));

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if ((!localStorage.getItem("auth-token") || !profile) && location.pathname !== "/unauthorized" && location.pathname !== "/login") {
      window.location.href = `${process.env.REACT_APP_LOGIN_PAGE}/${process.env.REACT_APP_ID}`;
    }
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh", overflow: "none" }}>
      {width >= 768 && <Siders />}
      <Layout>
        <Headers />
        <Breadcrumbs />
        <Content>
          <WrapperContent>{props.children}</WrapperContent>
        </Content>
        <Footers />
      </Layout>
    </Layout>
  );
};
